




import Vue from "vue";
import chatService from "@/services/chat.service";
import { error } from "console";

    export default Vue.extend({
        data(){
            return {
                longUrl: ''
            }
        },
        async mounted() {
            const fullUrl = window.location.href;
            const segmentos = new URL(fullUrl).pathname.split('/');
            const ultimoParametro = segmentos.pop();
            
            await this.ObtainQualtricsLongUrl(ultimoParametro);
        },
        methods: {
            async ObtainQualtricsLongUrl(id?: string){
                //this.longUrl = "https://claroperu.sjc1.qualtrics.com/jfe/form/SV_8zTR?Q_EED=eyJVc3VhcmlvIjoiQ2xhcm9Cb3QiLCJDYW5hbCI6IldBIiwiU2VydmljaW8iOiJDbGFyb0JvdCIsIkZlY2hhX0hvcmEiOiIzMS0wOC0yMDIzIDIxOjE1IiwiTW90aXZvX3Zpc2l0YTEiOiJNZSBheXVkYXLDrWEgbXVjaG8gcXVlIHJlc3BvbmRhcyBsYXMgc2lndWllbnRlcyBwcmVndW50YXMgc29icmUgbWkgYXRlbmNpw7NuIPCfkYkgPGEgdGFyZ2V0PVwiX2JsYW5rXCIgaHJlZj1cImh0dHBzOi8vY2xhcm9wZXJ1LnNqYzEucXVhbHRyaWNzLmNvbS9qZmUvZm9ybS9TVl85eU9OV0FHNWpHMkNnN0FcIj48Yj5hcXXDrTwvYj48L2E+IiwiTW90aXZvX3Zpc2l0YTIiOiJNZSBheXVkYXLDrWEgbXVjaG8gcXVlIHJlc3BvbmRhcyBsYXMgc2lndWllbnRlcyBwcmVndW50YXMgc29icmUgbWkgYXRlbmNpw7NuIPCfkYkgPGEgdGFyZ2V0PVwiX2JsYW5rXCIgaHJlZj1cImh0dHBzOi8vY2xhcm9wZXJ1LnNqYzEucXVhbHRyaWNzLmNvbS9qZmUvZm9ybS9TVl85eU9OV0FHNWpHMkNnN0FcIj48Yj5hcXXDrTwvYj48L2E+IiwiSURfQ29udmVyc2FjaW9uIjoiZTg2OWQyODEtYmM5Zi00ZmQ2LTliNzQtYjVlYjkzODk0ODkwIiwiVGlwb19DbGllbnRlIjoiIiwiVGllbXBvX0F0ZW5jaW9uIjoiMTI6NDg6NDcuOTI3NzA4OSJ9";
                let resultado = id || "";

                console.log("Resultado: " + resultado);

                await chatService.FindUrlLongForQualtrics(resultado).then(resp => {
                    console.log("Datos de servicio para obtener info: " + JSON.stringify(resp));
                    this.longUrl = resp.data.urlLong;
                    console.log("URL Long: " + this.longUrl);
                    
                }).catch(error => {
                    console.error("Ocurrio un error", error);
                })
                
            }
        }

    }) 
